<template>
<div>
  <b-card>
    <div class="text-right mb-3">
      <router-link class="btn btn-primary" :to="{name:'scorecardExcluded.create'}"><i class="fa fa-plus"></i> Criar</router-link>
    </div>
    <Grid name="IOperatorsGrid" v-bind:url="url" v-bind:columns="columns" :pageable='true' :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></Grid>
  </b-card>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import router from '@/router'
import lists from '@/components/States.js'

export default {
  name: 'IOperatorsGrid',
  components: {
    Grid
  },
  data() {
    return {
      schemaModelFields: {
        'created_at': {
          type: 'date'
        }
      },
      url: 'scorecard/excluded',
      columns: [{
        template: this.getBtnTemplate,
        title: '',
        width: '180px'
      },
      {
        field: 'id',
        title: 'Id',
        width: '120px'
      },
      {
        field: 'nif',
        title: 'NIF'
      },
      {
        field: 'date_start',
        title: 'Início',
        format: '{0:dd/MM/yyyy}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy'
            })
          }
        }
      },
      {
        field: 'date_end',
        title: 'Fim',
        format: '{0:dd/MM/yyyy}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy'
            })
          }
        }
      },
      {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }]
    }
  },
  methods: {
    getBtnTemplate: function(item) {
      var route = router.resolve({
        name: 'scorecardExcluded.edit',
        params: {
          id: item.id
        }
      })
      if (this.$auth.check('scorecardExcluded.edit')) {
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>'
      }
      return ''
    }
  }
}
</script>
